import { creditCardPayments } from "../_constants";

export const validateDfccOtherCreditCardRequest = (payload) => {
  return {
    type: creditCardPayments.VALIDATE_CLIENT_OTHER_CARD_REQUEST,
    payload,
  };
};

export const validateDfccOtherCreditCardComplete = (payload) => {
  return {
    type: creditCardPayments.VALIDATE_CLIENT_OTHER_CARD_COMPLETE,
    payload,
  };
};

export const validateDfccOtherCreditCardError = (payload) => {
  return {
    type: creditCardPayments.VALIDATE_CLIENT_OTHER_CARD_ERROR,
    payload,
  };
};

export const creditCardPayFromListRequest = (payload) => {
  return {
    type: creditCardPayments.CREDIT_CARD_PAY_FROM_LIST_REQUEST,
    payload,
  };
};

export const creditCardPayFromListComplete = (payload) => {
  return {
    type: creditCardPayments.CREDIT_CARD_PAY_FROM_LIST_COMPLETE,
    payload,
  };
};

export const creditCardPayFromListError = (payload) => {
  return {
    type: creditCardPayments.CREDIT_CARD_PAY_FROM_LIST_ERROR,
    payload,
  };
};

export const creditCardValidateAmountRequest = (payload) => {
  return {
    type: creditCardPayments.CREDIT_CARD_VALIDATE_AMOUNT_REQUEST,
    payload,
  };
};

export const creditCardValidateAmountComplete = (payload) => {
  return {
    type: creditCardPayments.CREDIT_CARD_VALIDATE_AMOUNT_COMPLETE,
    payload,
  };
};

export const creditCardValidateAmountError = (payload) => {
  return {
    type: creditCardPayments.CREDIT_CARD_VALIDATE_AMOUNT_ERROR,
    payload,
  };
};

export const setCreditCardBillPaymentFLow = (payload) => {
  return {
    type: creditCardPayments.SET_CREDIT_CARD_BILL_PAYMENT_FLOW,
    payload,
  };
};

export const creditCardClearFlowData = () => {
  return {
    type: creditCardPayments.CREDIT_CARD_CLEAR_FLOW_DATA,
    payload: [],
  };
};

export const creditCardClearFormData = () => {
  return {
    type: creditCardPayments.CREDIT_CARD_CLEAR_FORM_DATA,
    payload: [],
  };
};

export const creditCardPayBillRequest = (payload) => {
  return {
    type: creditCardPayments.CREDIT_CARD_PAY_BILL_REQUEST,
    payload,
  };
};

export const creditCardPayBillComplete = (payload) => {
  return {
    type: creditCardPayments.CREDIT_CARD_PAY_BILL_COMPLETE,
    payload,
  };
};

export const creditCardPayBillError = (payload) => {
  return {
    type: creditCardPayments.CREDIT_CARD_PAY_BILL_ERROR,
    payload,
  };
};

export const cardSettlementTypesRequest = (payload) => {
  return {
    type: creditCardPayments.CARD_SETTLEMENT_TYPES_REQUEST,
    payload,
  };
};

export const cardSettlementTypesComplete = (payload) => {
  return {
    type: creditCardPayments.CARD_SETTLEMENT_TYPES_COMPLETE,
    payload,
  };
};

export const cardSettlementTypesError = (payload) => {
  return {
    type: creditCardPayments.CARD_SETTLEMENT_TYPES_ERROR,
    payload,
  };
};

export const creditCardPayToBanksListRequest = (payload) => {
  return {
    type: creditCardPayments.CREDIT_CARD_PAY_TO_BANKS_REQUEST,
    payload,
  };
};

export const creditCardPayToBanksListComplete = (payload) => {
  return {
    type: creditCardPayments.CREDIT_CARD_PAY_TO_BANKS_COMPLETE,
    payload,
  };
};

export const creditCardPayToBanksListError = (payload) => {
  return {
    type: creditCardPayments.PAY_TO_BANKS_ERROR,
    payload,
  };
};

export const creditCardOtpConfirmationRequest = (payload) => {
  return {
    type: creditCardPayments.CREDIT_CARD_OTP_CONFIRMATION_REQUEST,
    payload,
  };
};

export const creditCardOtpConfirmationComplete = (payload) => {
  return {
    type: creditCardPayments.CREDIT_CARD_OTP_CONFIRMATION_COMPLETE,
    payload,
  };
};

export const creditCardOtpConfirmationError = (payload) => {
  return {
    type: creditCardPayments.CREDIT_CARD_OTP_CONFIRMATION_ERROR,
    payload,
  };
};

export const creditCardResendOTPRequest = (payload) => {
  return {
    type: creditCardPayments.CREDIT_CARD_OTP_RESEND_REQUEST,
    payload,
  };
};

export const creditCardResendOTPComplete = (payload) => {
  return {
    type: creditCardPayments.CREDIT_CARD_OTP_RESEND_COMPLETE,
    payload,
  };
};

export const creditCardResendOTPError = (payload) => {
  return {
    type: creditCardPayments.OTP_RESEND_ERROR,
    payload,
  };
};

export const clearCreditCardAvialbleStatus = (payload) => {
  return {
    type: creditCardPayments.CLEAR_CREDIT_CARD_AVAILABLE_STATUS,
    payload,
  };
};

export const setPayFrom = (payload) => {
  return {
    type: creditCardPayments.SET_PAY_FROM,
    payload,
  };
};
